import React, { MouseEvent } from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';

interface ExitProps extends IconProps {
  onClick?: () => void;
}

const Exit: React.FC<ExitProps> = ({ variant, size, className, onClick: clickHandler }) => {
  const onClick = (e: MouseEvent<SVGSVGElement>) => {
    if (clickHandler) {
      clickHandler();
      e.stopPropagation();
    }
  };

  return (
    <svg
      onClick={(e) => onClick(e)}
      className={cn(iconVariant({ variant, size, className }))}
      aria-hidden="true"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.46967 5.46967C5.76256 5.17678 6.23744 5.17678 6.53033 5.46967L12 10.9393L17.4697 5.46967C17.7626 5.17678 18.2374 5.17678 18.5303 5.46967C18.8232 5.76256 18.8232 6.23744 18.5303 6.53033L13.0607 12L18.5303 17.4697C18.8232 17.7626 18.8232 18.2374 18.5303 18.5303C18.2374 18.8232 17.7626 18.8232 17.4697 18.5303L12 13.0607L6.53033 18.5303C6.23744 18.8232 5.76256 18.8232 5.46967 18.5303C5.17678 18.2374 5.17678 17.7626 5.46967 17.4697L10.9393 12L5.46967 6.53033C5.17678 6.23744 5.17678 5.76256 5.46967 5.46967Z"
        fill="#010F55"
      />
    </svg>
  );
};

export default Exit;
